module.exports = __webpack_public_path__ + "93f48c6fadfce9c77f97d2e0fdc8f5fd.jpg";